<template>
    <div style="position: relative;">
        <textarea id="content2" name="content" style="width:500px; height:450px; visibility:hidden;"></textarea>
        <p class="editor-count"></p>
    </div>
</template>
<script>
export default {
    name: 'UE',
    props: {
        options: {
            type: Object,
            default: () => {
                return {}
            }
        },
        defaultMsg: String
    },
    data () {
        return {
            isShowPicture: false,
            isShowVideo: false
        }
    },
    created() {
        this.loadScript('/static/kindEditor/kindeditor-all.js', () => {
            this.loadScript('/static/kindEditor/zh-CN.js', () => {
                this.customePlugin();
                this.initEditor();
            });
        });
    },
    destroyed() {
        KindEditor.remove('#content2');
    },
    methods: {
        loadScript (url, fn) {
            const _QUIRKS = document.compatMode != 'CSS1Compat';
            const head = document.getElementsByTagName('head')[0] || (_QUIRKS ? document.body : document.documentElement);
            const script = document.createElement('script');
            head.appendChild(script);
            script.src = url;
            script.charset = 'utf-8';
            script.onload = script.onreadystatechange = function() {
                if (!this.readyState || this.readyState === 'loaded') {
                    if (fn) {
                        fn();
                    }
                    script.onload = script.onreadystatechange = null;
                    head.removeChild(script);
                }
            };
        },
        initEditor () {
            const _this = this;
            const config = Object.assign({}, {
                width: '100%',
                minHeight: 300,
                resizeType: 1,
                items : ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen'],
                afterChange : function(){
                    KindEditor('.editor-count').html('当前字数' + this.count('text') + '，最大上限'+ _this.options.wordLimit);
                },//统计字数
                allowFileManager : true,//下方功能按钮
            }, _this.options.config || {});
            this.editor = KindEditor.create('#content2', config);
            KindEditor('input[name=clear]').click(function(e){
                _this.editor.html(this.defaultMsg || '');
            });
            _this.editor.insertHtml('&nbsp;&nbsp;<house class="houseUnit">楼盘卡片</house>');

        },
        customePlugin () {
            const _this = this;
            KindEditor.lang({
				picture : '插入图片',
                video: '插入视频',
                addhouse: '插入楼盘',
                addContent:'插入内容'
			});
            KindEditor.plugin('picture', function(K) {
				var self = this, name = 'picture';
				self.clickToolbar(name, function() {
                    _this.isShowPicture = true;
				});
			});
            KindEditor.plugin('video', function(K) {
				var self = this, name = 'video';
				self.clickToolbar(name, function() {
                    _this.isShowVideo = true;
				});
			});
            KindEditor.plugin('addhouse', function(K) {
				var self = this, name = 'addhouse';
				self.clickToolbar(name, function() {
                    _this.$emit('addhouse');
				});
			});
            KindEditor.plugin('addContent', function(K) {
				var self = this, name = 'addContent';
				self.clickToolbar(name, function() {
                    _this.$emit('addContent');
				});
			});
        },
        pushContentHouse (msg) {
            this.editor.insertHtml(msg);
        },
        cropPicture () {
            const obj = document.querySelector('.ke-edit-iframe').contentDocument;
            const imgList = obj.getElementsByTagName("img");
            for(let i = 0; i < imgList.length; i ++) {
                const img = imgList[i];
                if (img.naturalWidth > 500) {
                    img.classList.add('is-need-crop');
                }
            }
        },
        clearContent(){
            const _this = this;
             _this.editor.html('');
        },
        getContent () {
            return {
                html: this.editor.html(),
                count: this.editor.count('text')
            }
        }
    },
}
</script>
<style lang="less">
@import url('/static/kindEditor/themes/default/default.css');
.ke-icon-picture{
    background-position: 0px -496px;
    width: 16px;
    height: 16px;
}
.ke-icon-video{
    background-position: 0px -528px;
    width: 16px;
    height: 16px;
}
.ke-toolbar-icon-url.ke-icon-addhouse{
    background-image: url(../../assets/img/add-house.png);
    width: 15px;
    height: 16px;
    background-size: 90%;
    margin-top: 3px;
}
.ke-toolbar-icon-url.ke-icon-addContent{
    background-image: url(../../assets/img/add-house.png);
    width: 15px;
    height: 16px;
    background-size: 90%;
    margin-top: 3px;
}
.editor-count{
    height: 20px;
    line-height: 20px;
    position: absolute;
    right: 0;
    bottom: 1px;
    font-size: 12px;
    color: #999;
    right: 14px;
}
</style>